// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".br-modal .br-modal__dialog{overflow-y:scroll}", "",{"version":3,"sources":["webpack://./resources/assets/js/anchor-modal/anchor-modal.vue"],"names":[],"mappings":"AAAA,4BAA4B,iBAAiB","sourcesContent":[".br-modal .br-modal__dialog{overflow-y:scroll}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
